import { useState } from "react";
import { communityPosts } from "@/mocks/home";

const liveTopics = [
  { name: "第七集反转讨论", count: "2.1k 人参与" },
  { name: "本周片单接龙", count: "1.5k 人参与" },
  { name: "花絮名场面", count: "980 人参与" },
  { name: "OST 歌单合集", count: "764 人参与" },
];

export default function CommunitySection() {
  const [liked, setLiked] = useState<Record<string, boolean>>({});

  const toggleLike = (id: string) => {
    setLiked((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  return (
    <section id="community" className="w-full bg-background-100">
      <div className="mx-auto w-full px-4 py-14 md:px-6 md:py-16">
        <div className="flex flex-col gap-5 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.2em] text-primary-600">
              <i className="ri-chat-smile-2-line w-4 h-4 flex items-center justify-center text-sm" />
              Community
            </span>
            <h2 className="mt-3 font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-3xl">
              吃瓜讨论区 · 看完记得说两句
            </h2>
            <p className="mt-2 max-w-xl text-sm leading-relaxed text-foreground-600">
              浏览是入口，聊天才是重点。这里的人都想把刚看完的想法说出来。
            </p>
          </div>
          <span className="inline-flex shrink-0 items-center gap-2 rounded-full border border-background-300 bg-background-50 px-4 py-2 text-sm text-foreground-600">
            <span className="h-2 w-2 animate-soft-pulse rounded-full bg-accent-500" />
            当前 1,286 人在线讨论
          </span>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-6 lg:grid-cols-12">
          <div className="lg:col-span-8">
            <div className="space-y-4">
              {communityPosts.map((post, index) => {
                const isLiked = Boolean(liked[post.id]);
                return (
                  <article
                    key={post.id}
                    className="animate-fade-up rounded-lg border border-background-200 bg-background-50 p-4 md:p-5"
                    style={{ animationDelay: `${index * 60}ms` }}
                  >
                    <div className="flex items-center gap-3">
                      <span
                        className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-full font-heading text-base font-bold ${post.tone}`}
                      >
                        {post.initial}
                      </span>
                      <div className="min-w-0">
                        <p className="truncate text-sm font-semibold text-foreground-900">
                          {post.user}
                        </p>
                        <p className="text-xs text-foreground-500">
                          {post.time} · 在 #{post.topic} 中发言
                        </p>
                      </div>
                    </div>

                    <p className="mt-3 text-sm leading-relaxed text-foreground-700">
                      {post.content}
                    </p>

                    <div className="mt-4 flex items-center gap-5">
                      <button
                        type="button"
                        onClick={() => toggleLike(post.id)}
                        className={
                          isLiked
                            ? "flex items-center gap-1.5 text-xs font-semibold text-accent-600 transition-colors"
                            : "flex items-center gap-1.5 text-xs font-medium text-foreground-500 transition-colors hover:text-accent-600"
                        }
                      >
                        <i
                          className={
                            isLiked
                              ? "ri-heart-fill w-4 h-4 flex items-center justify-center text-sm"
                              : "ri-heart-line w-4 h-4 flex items-center justify-center text-sm"
                          }
                        />
                        {post.likes + (isLiked ? 1 : 0)}
                      </button>
                      <span className="flex items-center gap-1.5 text-xs font-medium text-foreground-500">
                        <i className="ri-chat-3-line w-4 h-4 flex items-center justify-center text-sm" />
                        {post.replies}
                      </span>
                      <span className="ml-auto flex cursor-pointer items-center gap-1 text-xs font-medium text-foreground-500 transition-colors hover:text-primary-600">
                        <i className="ri-share-forward-line w-4 h-4 flex items-center justify-center text-sm" />
                        分享
                      </span>
                    </div>
                  </article>
                );
              })}
            </div>
          </div>

          <aside className="lg:col-span-4">
            <div className="rounded-lg border border-background-200 bg-background-50 p-5">
              <h3 className="font-heading text-base font-bold text-foreground-950">正在热聊</h3>
              <ul className="mt-4 space-y-3">
                {liveTopics.map((topic, index) => (
                  <li key={topic.name}>
                    <a
                      href="#topics"
                      className="flex items-center gap-3 rounded-md p-2 transition-colors hover:bg-background-100"
                    >
                      <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-md bg-accent-100 font-label text-xs font-bold text-accent-700">
                        {index + 1}
                      </span>
                      <span className="min-w-0 flex-1">
                        <span className="block truncate text-sm font-medium text-foreground-800">
                          #{topic.name}
                        </span>
                        <span className="block text-xs text-foreground-500">{topic.count}</span>
                      </span>
                      <i className="ri-arrow-right-s-line w-4 h-4 flex items-center justify-center text-base text-foreground-400" />
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div className="mt-5 rounded-lg border border-secondary-200 bg-secondary-100 p-5">
              <h3 className="font-heading text-sm font-bold text-secondary-950">社区公约</h3>
              <ul className="mt-3 space-y-2.5 text-xs leading-relaxed text-secondary-900">
                <li>理性吃瓜，讨论内容不针对任何个人。</li>
                <li>标题党可以，造谣不行，请以讨论作品为主。</li>
                <li>看料免费，尊重彼此的观点比争输赢重要。</li>
              </ul>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}